<template>
  <section
    id="open-source"
    class="padding-top-3xl padding-bottom-5xl"
    style="background-color: var(--white)"
  >
    <div class="container">
      <div class="row margin-bottom-4xl">
        <div class="column-12 text-center">
          <h1 class="h2 margin-y-md">Proudly Open Source</h1>
          <p class="line-length-xl margin-auto">
            In 2012, we created the first version of our open source icon, and it continues to be one of the top open source projects on Github. With the help
            of our subscription plans, it's only gotten better.
          </p>
        </div>
      </div>
      <div class="row align-center">
        <div class="column-12 tablet:column-6 laptop:column-4">
          <div
            class="card header gray"
            style="--card-header-background: var(--fa-lt-gravy)"
          >
            <div class="header">
              <font-awesome-icon
                :icon="$v7.solid.faHandHoldingHeart"
                size="2x"
              />
            </div>
            <div class="text-left">
              <h3 class="h5">Always Free</h3>
              <p>With every version, Font Awesome has always had free and open source icons. We'll always stay that way.</p>
            </div>
          </div>
        </div>
        <div class="column-12 tablet:column-6 laptop:column-4">
          <div
            class="card header gray"
            style="--card-header-background: var(--fa-lt-gravy)"
          >
            <div class="header">
              <font-awesome-icon
                :icon="$v7.solid.faRocketLaunch"
                size="2x"
              />
            </div>
            <div class="text-left">
              <h3 class="h5">Support Open Source</h3>
              <p>Thanks to Pro Subscribers, Font Awesome Free has increased by over 250% since version 4.</p>
            </div>
          </div>
        </div>
        <div class="column-12 tablet:column-6 laptop:column-4">
          <div
            class="card header gray"
            style="--card-header-background: var(--fa-lt-gravy)"
          >
            <div class="header">
              <font-awesome-icon
                :icon="$v7.solid.faShieldHalved"
                size="2x"
              />
            </div>
            <div class="text-left">
              <h3 class="h5">No Shenanigans</h3>
              <p>Need more icons or services? If you want them, you subscribe. We'll never sell your data.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row align-middle margin-top-lg text-center">
        <div class="column-12 laptop:column-7 laptop:offset-1 margin-bottom-xs laptop:margin-bottom-0">
          <a
            href="https://github.com/FortAwesome/Font-Awesome"
            target="_blank"
            class="strong display-flex align-middle align-center laptop:align-right"
            style="--link-color: var(--fa-navy); --link-hover-color: var(--fa-dk-blue)"
            @click="$posthog.capture('home:github_project_link_click', { location: 'open_source' })"
          >
            <div class="padding-right-md padding-y-sm">
              <font-awesome-icon
                :icon="$v7.brands.faGithub"
                size="2xl"
              />
            </div>
            <h5 class="margin-0 text-left">Font Awesome is one of the top open source projects on GitHub.</h5>
          </a>
        </div>
        <div class="column-12 laptop:column-3 margin-top-4xs laptop:text-left">
          <github-button
            href="https://github.com/FortAwesome/Font-Awesome"
            data-show-count="true"
            aria-label="Star FortAwesome/Font-Awesome on GitHub"
            @click.native="$posthog.capture('home:github_star_button_click', { location: 'open_source' })"
          >
            Star
          </github-button>
          <github-button
            href="https://github.com/FortAwesome/Font-Awesome/fork"
            data-show-count="true"
            aria-label="Fork FortAwesome/Font-Awesome on GitHub"
            @click.native="$posthog.capture('home:github_fork_button_click', { location: 'open_source' })"
          >
            Fork
          </github-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import GithubButton from 'vue-github-button'

  export default {
    name: 'OpenSource',

    components: {
      GithubButton
    }
  }
</script>
